import React from "react";

import { UnorderedList, OrderedList } from "../../common";

interface Props {
  ordered: boolean;
  children: React.ReactNode;
}

export const MappedList: React.FC<Props> = ({ ordered, children }) => {
  return ordered ? (
    <OrderedList>{children}</OrderedList>
  ) : (
    <UnorderedList>{children}</UnorderedList>
  );
};
